import { Card } from 'reactstrap';

export const PreviewCard = ({ className, bodyClass, ...props }) => (
  <Card className={`card-preview ${className || ''}`}>
    <div className={`card-inner ${bodyClass || ''}`}>{props.children}</div>
  </Card>
);
